import { FranklinLogo } from "@/components/ui/franklin-logo";
import { useLanguage } from "@/lib/i18n/LanguageContext";
import { useFranklinMadeDocumentIds } from "./franklinMade";

/** Franklin's logo beside the name of a document Franklin made; nothing otherwise. */
export function FranklinMadeMark({
  buildingId,
  documentId,
}: {
  buildingId: string | undefined;
  documentId: string | number;
}) {
  const { t } = useLanguage();
  const ids = useFranklinMadeDocumentIds(buildingId);
  if (!ids.has(String(documentId))) return null;
  const label = t.documents.table.createdByFranklin;
  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      data-testid="franklin-made-mark"
      className="inline-flex flex-shrink-0 items-center"
    >
      <FranklinLogo
        size="xs"
        showBorder={false}
        alt=""
        className="h-4 w-4"
        imageClassName="h-4 w-4"
      />
    </span>
  );
}
